export default __webpack_public_path__ + "static/media/bg1.0380b1f1.jpg";